export const state = {

    customreleases: [],
    systemCustomrelease: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/customreleases/state.js